const React = require('react');

const CommonTypes = require('../common/Types.jsx');
const Config = require('../utility/Config.jsx');
const Item = require('../common/ItemV2.jsx');
const Name = require('../utility/Name.jsx');
const Token = require('../utility/Token.jsx');
const Utilities = require('../utility/Utilities.jsx');

// #region META

const TokensMeta = (data) => {
    return [
        Token.getWrappedTokenConfig('List Order Number', Token.ListOrderNumber),
        Token.getWrappedTokenConfig('Artist Name', Token.Artist.Name),
        Token.getWrappedTokenConfig('Artist Lifespan', Token.Artist.Lifespan),
        Token.getWrappedTokenConfig('Title', Token.Inventory.Title),
        Token.getEditionInfoTokenConfig(),
        Token.getWrappedTokenConfig('Created Date', Token.Date),
        Token.getWrappedTokenConfig('Medium', Token.Inventory.Medium),
        Token.getWrappedTokenConfig('Dimensions', Token.Inventory.Dimensions),
        Token.getWrappedTokenConfig('Alternate Dimensions', Token.Inventory.AlternateDimensions),
        Token.getWrappedTokenConfig('Framing', Token.Inventory.Framed),
        Token.getWrappedTokenConfig('Inventory Number', Token.Inventory.Number),
        Token.getWrappedTokenConfig('SKU', Token.Inventory.SKU),
        Token.getWrappedTokenConfig('Location', Token.Inventory.Location),
        Token.getCurrencyTokenConfig('Retail Price', Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization), Token.Inventory.Price, Token.firstLineCurrencyDifferentToggleOption),
        Token.getAlternatePricesTokenConfig(),
        Token.getWrappedTokenConfig('Price Override', Token.Inventory.DisplayPrice),
        Token.getWrappedTokenConfig('Notes', Token.Notes),
        Token.getWrappedTokenConfig('Private Notes', Token.PrivateNotes),
    ]
};
const TypeConfigMeta = {
    defaultDesign: `
${Utilities.wrapTextForEditor({ text: `{${Token.Artist.Name}("before":"","after":"")}`, token: Token.Artist.Name })}
<p class="p">${Utilities.wrapTextForEditor({ text: `{${Token.Inventory.Title}("before":"","after":"")}`, textExtras: `style="display:inline;font-style:italic;"`, token: Token.Inventory.Title, wrapWithTag: false })}${Utilities.wrapTextForEditor({ text: `{${Token.Inventory.Edition}("limited":"${Utilities.Inventory.getEditionFormatString('limited')}","unlimited":"${Utilities.Inventory.getEditionFormatString('unlimited')}")}`, textExtras: `style="display:inline;"`, token: Token.Inventory.Edition, wrapWithTag: false })}${Utilities.wrapTextForEditor({ text: `{${Token.Date}("before":", ","after":"")}`, textExtras: `style="display:inline;"`, token: Token.Date, wrapWithTag: false })}</p>
${Utilities.wrapTextForEditor({ text: `{${Token.Inventory.Medium}("before":"","after":"")}`, token: Token.Inventory.Medium })}
${Utilities.wrapTextForEditor({ text: `{${Token.Inventory.Dimensions}("before":"","after":"")}`, token: Token.Inventory.Dimensions })}
${Utilities.wrapTextForEditor({ text: `{${Token.Inventory.AlternateDimensions}("before":"","after":"")}`, token: Token.Inventory.AlternateDimensions })}
${Utilities.wrapTextForEditor({ text: `{${Token.Inventory.Framed}("before":"","after":"")}`, token: Token.Inventory.Framed })}
${Utilities.wrapTextForEditor({ text: `{${Token.Inventory.Number}("before":"Inventory #: ","after":"")}`, token: Token.Inventory.Number })}
${Utilities.wrapTextForEditor({ text: `{${Token.Inventory.SKU}("before":"SKU: ","after":"")}`, token: Token.Inventory.SKU })}
${Utilities.wrapTextForEditor({ text: `{${Token.Inventory.Location}("before":"","after":"")}`, token: Token.Inventory.Location })}`,
    defaultDesignOrder: Utilities.wrapTextForEditor({ text: `{${Token.ListOrderNumber}("before":"","after":".")}`, token: Token.ListOrderNumber }),
    panel: {
        block: (defaultDesign) => Item.Meta.TypeConfig.panel.block(defaultDesign || TypeConfigMeta.defaultDesign),
        style: Item.Meta.TypeConfig.panel.style
    }
};

// #endregion META

// #region CONTAINER

const ItemBlocks = {
    get: (group) => [
        ...CommonTypes.BlocksV2.content.get(group),
        {
            id: Name.Block.Inventory.Image,
            component: Item.Image.Component,
            config: {
                Block: Item.Image.TypeConfig.panel.block(),
                Style: Item.Image.TypeConfig.panel.style()
            },
            display: 'Item Image',
            group,
            image: ''
        },
        {
            id: Name.Block.Inventory.Meta,
            component: Item.Meta.Component,
            config: {
                Block: TypeConfigMeta.panel.block(),
                Style: TypeConfigMeta.panel.style()
            },
            display: 'Item Meta',
            group,
            image: ''
        },
        {
            id: Name.Block.ListOrderNumber,
            blockType: Name.Block.Inventory.Meta,
            component: Item.Meta.Component,
            config: {
                Block: TypeConfigMeta.panel.block(TypeConfigMeta.defaultDesignOrder),
                Style: TypeConfigMeta.panel.style()
            },
            display: 'List Order Number',
            group,
            image: ''
        }
    ]
}
const ItemContainer = Config.withBlockRendering(Item.Container.Component, ItemBlocks.get(), (props, block) => {
    if (!block.type) {
        return;
    }
    switch (block.type.value) {
        case Name.Block.Columns:
            if (block.config && block.config.Block && block.config.Block.renderHeaderOnlyFirst) {
                return { renderHeader: props.index == 0 }
            }
        case Name.Block.Inventory.Image:
            return { transform: 'c_fit' };
    }
});
const ItemContainerTypeConfig = {
    defaultDesign: (data) => ({
        "Config": {
            "blocks": [
                {
                    "config": {
                        "Block": {
                            "columnCount": "5",
                            "alignmentHeader-col1": "tl",
                            "alignment-col1": "tl",
                            "collapseIfEmpty-col1": true,
                            "width-col1": {
                                "unit": "%",
                                "value": "6"
                            },
                            "alignmentHeader-col2": "ml",
                            "alignment-col2": "tl",
                            "paddingRight-col2": {
                                "unit": "px",
                                "value": "20"
                            },
                            "width-col2": {
                                "unit": "px",
                                "value": "150"
                            },
                            "alignmentHeader-col3": "tl",
                            "alignment-col3": "tl",
                            "width-col3": {
                                "unit": "%"
                            },
                            "alignmentHeader-col4": "mr",
                            "alignment-col4": "mr",
                            "collapseIfEmpty-col4": true,
                            "width-col4": {
                                "unit": "%",
                                "value": "15"
                            },
                            "alignmentHeader-col5": "mr",
                            "alignment-col5": "mr",
                            "collapseIfEmpty-col5": true,
                            "width-col5": {
                                "unit": "%",
                                "value": "15"
                            },
                            "alignmentHeader-col6": "tl",
                            "alignment-col6": "tl",
                            "width-col6": {
                                "unit": "%"
                            },
                            "renderHeaderOnlyFirst": true
                        },
                        "Style": {}
                    },
                    "dataType": "layout",
                    "id": `${Name.Block.Columns}-${new Date().getTime()}`,
                    "type": {
                        "value": "columns"
                    },
                    "blocks": [
                        [
                            {
                                "config": {
                                    "Block": {
                                        "design": TypeConfigMeta.defaultDesignOrder
                                    },
                                    "Style": {}
                                },
                                "id": `${Name.Block.Inventory.Meta}-0-${new Date().getTime()}`,
                                "type": {
                                    "value": Name.Block.Inventory.Meta
                                }
                            }
                        ],
                        [
                            {
                                "config": {
                                    "Block": {
                                        "width": {
                                            "unit": "px",
                                            "value": "150"
                                        }
                                    },
                                    "Style": {
                                        "textAlign": "left"
                                    }
                                },
                                "id": `${Name.Block.Inventory.Image}-${new Date().getTime()}`,
                                "type": {
                                    "value": Name.Block.Inventory.Image
                                }
                            }
                        ],
                        [
                            {
                                "config": {
                                    "Block": {
                                        "design": TypeConfigMeta.defaultDesign
                                    },
                                    "Style": {}
                                },
                                "id": `${Name.Block.Inventory.Meta}-1-${new Date().getTime()}`,
                                "type": {
                                    "value": Name.Block.Inventory.Meta
                                }
                            }
                        ],
                        [
                            {
                                "config": {
                                    "Block": {
                                        "design": Utilities.wrapTextForEditor({ tagExtras: `style="text-align:right;"`, text: `{${Token.Inventory.Price}("format":"${Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization)}","formatFirst":"")}`, token: Token.Inventory.Price })
                                    },
                                    "Style": {}
                                },
                                "id": `${Name.Block.Inventory.Meta}-2-${new Date().getTime()}`,
                                "type": {
                                    "value": Name.Block.Inventory.Meta
                                }
                            }
                        ],
                        [
                            {
                                "config": {
                                    "Block": {
                                        "design": Utilities.wrapTextForEditor({ tagExtras: `style="text-align:right;"`, text: `{${Token.Inventory.DisplayPrice}("before":"","after":"")}`, token: Token.Inventory.DisplayPrice })
                                    },
                                    "Style": {}
                                },
                                "id": `${Name.Block.Inventory.Meta}-3-${new Date().getTime()}`,
                                "type": {
                                    "value": Name.Block.Inventory.Meta
                                }
                            }
                        ]
                    ]
                }
            ]
        },
        "Type": Name.Content.PricelistInventoryItem
    })
}

// #endregion CONTAINER

module.exports = {
    Container: {
        Blocks: ItemBlocks,
        Component: ItemContainer,
        TypeConfig: ItemContainerTypeConfig
    },
    Image: Item.Image,
    Meta: {
        Component: Item.Meta.Component,
        Tokens: TokensMeta,
        TypeConfig: TypeConfigMeta
    }
}